export const truncateFilter = () => {
	return (text, length, end) => {
		if (length == null) {
			length = 10;
		} else if (isNaN(length)) {
			length = 10;
		}
		if (end == null) {
			end = '...';
		} else if (typeof end !== 'string') {
			end = end.toString();
		}
		if (text == null) {
			return '';
		}
		if (text.length <= length || text.length - end.length <= length) {
			return text;
		}

		return String(text).substring(0, length - end.length) + end;
	};
};
